import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

import "./components.css";

function Skills() {
	const { scrollYProgress } = useScroll();
	const line1ScrollRange = [0, 1.5]; // adjust these values to control the point of scroll where animation begins and ends
	const line2ScrollRange = [0, 1.5]; // adjust these values to control the point of scroll where animation begins and ends

	const line1TranslateX = useTransform(scrollYProgress, line1ScrollRange, [
		"0vw",
		"100vw",
	]);
	const line2TranslateX = useTransform(scrollYProgress, line2ScrollRange, [
		"0vw",
		"-100vw",
	]);

	return (
		<section className="skills-animated" aria-label="Skills">
			<motion.div
				id="line-1"
				className="animated-skills-strip line-1"
				style={{ translateX: line1TranslateX }}
			>
				<span className="skill">Product Design</span>
				<span className="skill">UX Research</span>
				<span className="skill">Wireframing</span>
				<span className="skill">Visual Design</span>
			</motion.div>
			<motion.div
				id="line-2"
				className="animated-skills-strip line-2"
				style={{ translateX: line2TranslateX }}
			>
				<span className="skill">Web Development</span>
				<span className="skill">React</span>
				<span className="skill">No Code</span>
			</motion.div>
		</section>
	);
}

export default Skills;
